import React from 'react';

import { router } from 'expo-router';
import { ScrollView, StyleSheet } from 'react-native';

import { CardModal } from 'components/card-modal';
import { t } from 'state/intl/translations';
import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';

import { DeliveryTermsCanada } from './delivery-terms-canada';
import { DeliveryTermsUS } from './delivery-terms-us';

export const DeliveryTermsContent = () => {
  const isCanada = region === Region.CA;

  return (
    <CardModal
      headerText={t('deliveryTermsHeading')}
      onDismiss={() => router.dismiss()}
      scrollView={true}
      noDesktopWebMaxWidth={true}
    >
      <ScrollView contentContainerStyle={styles.container}>
        {isCanada ? <DeliveryTermsCanada /> : <DeliveryTermsUS />}
      </ScrollView>
    </CardModal>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    paddingBottom: 32,
  },
});
